module.exports = __webpack_public_path__ + "epdf-app/dashboard/resumption/resumption-q9Am8ktM.html";